import type { i18nRouter} from 'next-i18n-router'

type i18nRouterConfig = Parameters<typeof i18nRouter>[1]

const i18nConfig = {
  locales: ['en', 'fr'],
  defaultLocale: 'fr',
  namespaces: ['default', 'home', 'commun', 'overlay'],
}

export const i18nRouterConfig: i18nRouterConfig = {
  locales: i18nConfig.locales,
  defaultLocale: i18nConfig.defaultLocale,
  prefixDefault: true,
}

export default i18nConfig;